import { useLocalization } from '@lib/localization';
import { Box, FormControl, MenuItem, Select } from '@mui/material';
import { type SelectChangeEvent } from '@mui/material/Select';

const dateRangeOptions = [
  { value: 7, label: 'Statistic_LastWeek' },
  { value: 30, label: 'Statistic_LastMonth' },
  { value: 90, label: 'Statistic_LastQuarter' },
  { value: 365, label: 'Statistic_LastYear' },
  { value: 0, label: 'Statistic_AllTime' },
] as const;

export type DateRangePreset = typeof dateRangeOptions[number]['value'];

interface DateRangePickerProps { value: DateRangePreset; onChange: (value: DateRangePreset) => void; }

const DateRangePicker: React.FC<DateRangePickerProps> = ({ value, onChange }) => {
  const { t } = useLocalization();

  const handleChange = (e: SelectChangeEvent<DateRangePreset>) => {
    const newPreset = e.target.value as DateRangePreset;

    onChange(newPreset);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select<DateRangePreset>
          value={value}
          onChange={handleChange}
          displayEmpty
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.23)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.4)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2196f3',
            },
          }}
        >
          {dateRangeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {t(option.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default DateRangePicker;
